<div class="condition-rule-container">
  <form [formGroup]="form">
    <div class="condition-rule">
      <div class="condition-rule-question">
        @if (index === 0) {
          <label>Question</label>
        }
        <app-input-select controlName="elementId" [items]="elementOptions" [parentForm]="form"></app-input-select>
      </div>

      <div class="condition-rule-operator">
        @if (index === 0) {
          <label>Operator</label>
        }
        <app-input-select controlName="operator" [items]="operatorOptions" [parentForm]="form"></app-input-select>
      </div>

      <div class="condition-rule-answer">
        @if (index === 0) {
          <label>Value</label>
        }
        <app-input-select controlName="value" [items]="valueOptions" [parentForm]="form"></app-input-select>
      </div>

      <div class="condition-rule-action">
        <app-button [iconOnly]="true" faIcon="far fa-times" size="sm" variant="info" type="button" (click)="removeCondition()" />
      </div>
    </div>
  </form>
</div>
